// @ts-nocheck
import React, {Component, useState} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
    faPlay,
    faPause,
    faDownload,
    faPianoKeyboard,
    faMusic,
    faLips,
    faCheckCircle,
    faGuitar,
    faGuitars,
    faPiano,
    faPeopleGroup,
    faDrum,
    faCompactDisc,
    faWaveform
} from '@fortawesome/pro-solid-svg-icons';
import {
  faCloudArrowUp,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {LinearProgress, IconButton, duration} from "@mui/material";
import {useDispatch, useSelector} from "react-redux";
import {useGlobalAudioSlice} from "app/components/GlobalAudioPlayer/slice";
import {selectCurrentSong, selectIsPlaying, selectProgress} from "app/components/GlobalAudioPlayer/slice/selectors";
import {useOutletContext} from "react-router-dom";
import {useCreatorUpsellModalSlice} from "app/components/CreatorUpsellModal/slice";
import {Api} from "store/api";
import { AudioUrlWaveformVisualizer } from '../AudioUrlWaveformVisualizer';

// TODO
interface Props {
  style?: React.CSSProperties;
  uniqueKey: string;
  audioFileId: string;
  downloadCount: number;
  url: string;
  filename: string;
  displaySong: {
    title: string;
    singer?: string;
    url: string;
  };
  audioType: string;
  audioFile: any;
  isHighlighted?: boolean;
  playButtonElement?: React.ReactNode;
  isSmall?: boolean;
  hideDownloadButton?: boolean;
  overrideDownloadButtonClickedHandler?: () => {};
  skipCheckSubForDownload?: boolean;
}

const AudioFileRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

const AudioFileContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  /* border-radius: 25px; */
  /* background: var(--background-paper-elevation-0, #180D23); */
  //
  // border-radius: ${props => props.small ? '20px' : '10px'};
  padding-left: ${props => props.small ? '5px' : '8px'};
  padding-right: ${props => props.small ? '5px' : '8px'};
  box-sizing: border-box;
  border: 1px solid #00000000;

  min-width: 0;
  margin-bottom: 4px;
  margin-top: 4px;
`;

const AudioIconAndTitle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  overflow: hidden;
`;
const AudioTitleAndWaveform = styled.div`
  flex-grow: 1;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  position: relative;

`;


const AudioTypeContainer = styled.div`
  flex-grow: 1;
  
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  color: rgba(245, 225, 255, 0.74);

  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  
  font-family: "Raleway";
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  
  margin-right: 10px;
`;

const AudioIconContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  text-align: center;
  text-overflow: ellipsis;
  font-family: "Raleway";
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  
  margin-right: 10px;
`;

const DownloadButtonElementContainer = styled.div`
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: -4px;
`

const RightButton = styled.div`
  flex-shrink: 0;
  
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: ${props => props.small ? '5px' : '10px'};
  width: ${props => props.small ? '20px' : '40px'};
  height: ${props => props.small ? '20px' : '40px'};
  border-radius: 50%;
  border: none;
  outline: none;
  // For FontAwesomeIcon
  font-size: ${props => props.small ? '20px' : '40px'};

  .fa-2xs {
    font-size: 22px;
  }
  
  .fa-check {
    color: #55CDC4;
  }
`
const DownloadButton = styled.a`
  color: #F5E1FF;
  &:hover {
    color: #FF74E9;
  }
`;

const DownloadCheckmark = styled.div`
  position: absolute;
  bottom: 3px;
  right: 4px;
  font-size: 10px;  
  color: #55CDC4;
  background-color: #251A30;
  border-radius: 50%;
  padding: 1px;
`;

function AudioFileStreamable(props: Props) {
  const [userProfile] = useOutletContext();

  const dispatch = useDispatch();
  const { actions: globalAudioActions } = useGlobalAudioSlice()
  const { actions: creatorUpsellModalActions } = useCreatorUpsellModalSlice()
  const currentSong = useSelector(selectCurrentSong)
  const isPlaying = useSelector(selectIsPlaying)
  const progress = useSelector(selectProgress)
  const isThisAudioFilePlaying = isPlaying && currentSong?.url === props.url
  const [hasDownloaded, setHasDownloaded] = useState<boolean>(false)

  const handlePlay = () => {
    // setPlaying(true);
    dispatch(globalAudioActions.setCurrentSong(props.displaySong))
    dispatch(globalAudioActions.setIsPlaying(true))
  };

  const handlePause= () => {
    // setPlaying(false);
    dispatch(globalAudioActions.setIsPlaying(false))
  };

  const handleDownloadClicked = () => {
      if (props.overrideDownloadButtonClickedHandler && props.overrideDownloadButtonClickedHandler !== undefined) {
        props.overrideDownloadButtonClickedHandler();
        return;
      }

      let url = props.url || '';
      let filename = props.filename || '';
      let audioFileId = props.audioFileId;
      // TODO this is hacky maybe fix the root cause
      // if filename has multiple .extensions, remove all of them except the last one before downloading
      
      let finalFilename = filename;
      if (filename.split('.').length > 1) {
        finalFilename = filename.split('.')[0] + '.' + filename.split('.').pop();
      }
      // Add .wav extension if filename doesn't have an audio extension
      if (!finalFilename.match(/\.(wav|mp3|ogg|flac|m4a)$/i)) {
        finalFilename += '.wav';
      }


      // if subscribed
      if (userProfile.plan?.includes('creator') || userProfile.plan?.includes('starter') || props.skipCheckSubForDownload) {
          // console.log(url)
          // window.location.href = url
          fetch(url)
            .then(response => response.blob())
            .then(blob => {
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement("a");
              a.href = url;
              
              a.download = finalFilename; // Forces download
              a.click();
              window.URL.revokeObjectURL(url);
              setHasDownloaded(true)
            });

          try {
            Api.incrementAudioFileDownloadCount(audioFileId)
          } catch (error) {
            console.error('Failed to increment audio file download count', error)
          }
      } else {
          console.log('clicked download')
          dispatch(creatorUpsellModalActions.updateTitle("Subscribe to download this file"))
          dispatch(creatorUpsellModalActions.open())
      }
  }

  // TODO figure out why normal way of doing PropTypes props error typescript
  // @ts-ignore
  let url = props.url || '';
  // @ts-ignore
  let filename = props.filename || '';
  // TODO this is hacky maybe fix the root cause
  // if filename has multiple .extensions, remove all of them except the last one before downloading
  let finalFilename = filename.split('.')[0].slice(10) + '.' + filename.split('.').pop();
  // @ts-ignore
  let uniqueKey = props.uniqueKey || '';
  // @ts-ignore
  let playButtonElement = props.leftButtonElement || (
      <IconButton onClick={!isThisAudioFilePlaying ? handlePlay : handlePause} sx={{ flexShrink: 0 }}>
          {!isThisAudioFilePlaying ? <FontAwesomeIcon icon={faPlay} size="xs"/> : <FontAwesomeIcon icon={faPause} size="xs"/>}
      </IconButton>
  );
  let audioType = props.audioType || undefined;
  let downloadCount = props.downloadCount || 0;
  let audio = props.audioFile || undefined;

  let isSmall = !!props.small
  let downloadButtonElement = props.downloadButtonElement || (
      <RightButton small={isSmall}>
          <DownloadButton
              // @ts-ignore
              onClick={handleDownloadClicked}
          >
            <FontAwesomeIcon icon={faDownload} size="2xs"/>
            {
              (hasDownloaded || downloadCount > 0) && (
                <DownloadCheckmark>
                  <FontAwesomeIcon icon={faCheckCircle} size="3xs" />
                </DownloadCheckmark>
              )
            }
          </DownloadButton>
      </RightButton>
  );

  // @ts-ignore
  let hidePlayButtonBackground = !!props.playButtonElement


  let audioTypeIcon = <FontAwesomeIcon icon={faCloudArrowUp} />
  let audioTypeText = props.displaySong.title
  if (audioType == 'mixed') {
      audioTypeIcon =  <FontAwesomeIcon icon={faMusic} />
      audioTypeText = "Full Song Output"
  } else if (audioType == 'instrumental') {
      audioTypeIcon = <FontAwesomeIcon icon={faPianoKeyboard} />
      audioTypeText = "Extracted Instrumental"
  } else if (audioType == 'vocal-inference') {
      audioTypeIcon = <FontAwesomeIcon icon={faLips} />
      audioTypeText = finalFilename || "Swapped Vocal"
  } else if (audioType?.includes('bass')) {
      audioTypeIcon = <FontAwesomeIcon icon={faGuitar} />
      audioTypeText = "Bass"
  } else if (audioType?.includes('guitar')) {
    audioTypeIcon = <FontAwesomeIcon icon={faGuitars} />
    audioTypeText = "Guitar"
  } else if (audioType?.includes('piano')) {
    audioTypeIcon = <FontAwesomeIcon icon={faPiano} />
    audioTypeText = "Piano"
  } else if (audioType?.includes('drums')) {
    audioTypeIcon = <FontAwesomeIcon icon={faDrum} />
    audioTypeText = "Drums/Percussion"
  } else if (audioType?.includes('lead-vocal')) {
    audioTypeIcon = <FontAwesomeIcon icon={faLips} />
    audioTypeText = "Lead Vocal"
  } else if (audioType?.includes('vocals')) {
    if (audioType?.includes('background')) {
      audioTypeText = "Background Vocals"
      audioTypeIcon = <FontAwesomeIcon icon={faPeopleGroup} />
    } else {
      audioTypeIcon = <FontAwesomeIcon icon={faPeopleGroup} />
      audioTypeText = "All Vocals"
      if (audioType?.includes('alt')) {
        audioTypeText = "All Vocals (alternate)"
      }
    }
  } else if (audioType?.includes('instrumental')) {
    audioTypeIcon = <FontAwesomeIcon icon={faCompactDisc} />
    audioTypeText = "Instrumental"
    if (audioType?.includes('alt')) {
      audioTypeText = "Instrumental (alternate)"
    }
  } else if (audioType?.includes('other')) {
    audioTypeIcon = <FontAwesomeIcon icon={faWaveform} />
    audioTypeText = "Other"
    if (audioType?.includes('alt')) {
      audioTypeText = "Other (alternate)"
    }
  } else if (audioType?.includes('sample')) {
    audioTypeIcon = <FontAwesomeIcon icon={faCompactDisc} />
  }

  return (
  <AudioFileRow style={{ backgroundColor: props.isHighlighted ? 'rgba(245, 225, 255, 0.12) !important' : 'none'}}>
    <AudioFileContainer small={isSmall} style={props.style}>
      {playButtonElement}
      <AudioTitleAndWaveform>
        <AudioIconAndTitle>
            <AudioIconContainer>
              {audioTypeIcon}
            </AudioIconContainer>
            <AudioTypeContainer>
              {audioTypeText}
            </AudioTypeContainer>
        </AudioIconAndTitle>
        <AudioUrlWaveformVisualizer url={url} currentTime={isThisAudioFilePlaying ? progress : 0} onPlay={handlePlay} />
      </AudioTitleAndWaveform>
    </AudioFileContainer>
    {!props.hideDownloadButton &&
      <DownloadButtonElementContainer>
        {downloadButtonElement}
      </DownloadButtonElementContainer>
    }
  </AudioFileRow>
  );
};


export default AudioFileStreamable;